type ReloadListener = () => void;
type TaskCheckedListener = (taskId: string, checked: boolean) => void;

const taskReloadListeners = new Set<ReloadListener>();
const taskCheckedListeners = new Set<TaskCheckedListener>();
const noteReloadListeners = new Set<ReloadListener>();
const goalReloadListeners = new Set<ReloadListener>();
const calendarReloadListeners = new Set<ReloadListener>();

export const addTaskReloadListener = (listener: ReloadListener) => {
    taskReloadListeners.add(listener);
};

export const removeTaskReloadListener = (listener: ReloadListener) => {
    taskReloadListeners.delete(listener);
};

export const triggerTaskReload = () => {
    taskReloadListeners.forEach(listener => {
        try {
            listener();
        } catch (e) {
            console.error('Task reload listener error:', e);
        }
    });
};

export const addTaskCheckedListener = (listener: TaskCheckedListener) => {
    taskCheckedListeners.add(listener);
};

export const removeTaskCheckedListener = (listener: TaskCheckedListener) => {
    taskCheckedListeners.delete(listener);
};

export const triggerTaskCheckedUpdate = (taskId: string, checked: boolean) => {
    taskCheckedListeners.forEach(listener => {
        try {
            listener(taskId, checked);
        } catch (e) {
            console.error('Task checked listener error:', e);
        }
    });
};

export const addNoteReloadListener = (listener: ReloadListener) => {
    noteReloadListeners.add(listener);
};

export const removeNoteReloadListener = (listener: ReloadListener) => {
    noteReloadListeners.delete(listener);
};

export const triggerNoteReload = () => {
    noteReloadListeners.forEach(listener => {
        try {
            listener();
        } catch (e) {
            console.error('Note reload listener error:', e);
        }
    });
};

export const addGoalReloadListener = (listener: ReloadListener) => {
    goalReloadListeners.add(listener);
};

export const removeGoalReloadListener = (listener: ReloadListener) => {
    goalReloadListeners.delete(listener);
};

export const triggerGoalReload = () => {
    goalReloadListeners.forEach(listener => {
        try {
            listener();
        } catch (e) {
            console.error('Goal reload listener error:', e);
        }
    });
};

export const addCalendarReloadListener = (listener: ReloadListener) => {
    calendarReloadListeners.add(listener);
};

export const removeCalendarReloadListener = (listener: ReloadListener) => {
    calendarReloadListeners.delete(listener);
};

export const triggerCalendarReload = () => {
    calendarReloadListeners.forEach(listener => {
        try {
            listener();
        } catch (e) {
            console.error('Calendar reload listener error:', e);
        }
    });
};

export const triggerAllReload = () => {
    triggerTaskReload();
    triggerNoteReload();
    triggerGoalReload();
    triggerCalendarReload();
};
